module.exports = __webpack_public_path__ + "img/remislogo.553be760.svg";